module.exports = __webpack_public_path__ + "img/titleEle.0264f92f.svg";